import React, { useState } from 'react';
import ImageCarousel from '../components/image-carousel';
import '../styles/whats-happening.scss';
import BodyText from '../components/woolwich-portable-text';

const WhatsHappeningItem = ({ item }) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className='happening-item'>
      <div className='happening-item__carousel-harness'>
        <ImageCarousel images={item.imageSlider} video={item.video} autoPlay={false} controls={true}/>
      </div>
      <div className='happening-item__content'>
        <div className='happening-item__title'>{item.title}</div>
        <BodyText blocks={item._rawContent} readMore />
      </div>
    </div>            
  );
};

export default WhatsHappeningItem;


